module.exports = __webpack_public_path__ + "static/media/header.b7b42426.png";